import React from "react";
import { Container } from "./Container";
import "./styles.scss";

import CardContainer from "../CardContainer/CardContainer";
import truncate from "../../utils/truncate";
import numberToComma from "../../utils/numberToComma";

const CardItem = (props) => {
  const { item, desc, price, photo, saved, like, navigate, favourite } = props;
  return (
    <Container>
      <CardContainer
        cardLeft={
          <div className="heart-container" onClick={favourite}>
            {like ? (
              <span style={{ color: "#0279B8" }} onClick={saved}>
                <i class="fa fa-heart" aria-hidden="true"></i>
              </span>
            ) : (
              <i class="fa fa-heart-o" aria-hidden="true"></i>
            )}
          </div>
        }
        photo={photo}
        item={truncate(item, 25)}
        desc={truncate(desc, 25)}
        price={numberToComma(price)}
        action={navigate}
      />
    </Container>
  );
};

export default CardItem;
